export const COUNTRY_DETECTION = {
  INTERNATIONAL_POPUP_URL_PARAM: 'showIntlPopup',
  INTERNATIONAL_POPUP_LOCALSTORAGE_PARAM: 'showIntlPopup',
  COUNTRY_SWITCH_LOCALSTORAGE_PARAM: 'showCountrySwitchPopup',
};
